Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  var formatString = format || this.money_format;
  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

class EGSubscriptionV6 extends HTMLElement {
  constructor() {
    super();
    this.dynamicData = JSON.parse(this.querySelector("[dynamic-data]").textContent);
    this.isSubscribe = false;
    window.addGiftToCart = false;
  }

  connectedCallback() {
    this.addEventListener("change", this.updateSellingPlan.bind(this))
    this.updateSellingPlan();

    const onetimeLink = this.querySelector("[data-onetime-link]");
    if (onetimeLink) onetimeLink.addEventListener("click", this.buyOneTime.bind(this));


    window.addEventListener("aftersell-upcart:public-events:added-to-cart", (e) => {
      clearInterval(interval)
      // this.updateSellingPlan();

      // console.log(e.detail);
      

      // if (e.detail.item.properties["__gift_excluded"] && window.addGiftToCart) {
      //   window.addGiftToCart = false;
      // }
    })

    const interval = setInterval(() => {this.updateSellingPlan()}, 500);
    setTimeout(() => {clearInterval(interval)}, 8000);
  }

  updateSellingPlan(event = false) {
    // Selling plans are named "<dog size>: Every {X} days". The size part is translated,
    // so the tokens come from the theme locales via snippets/selling-plan-tokens.liquid.
    // Each entry holds the translated token plus the English original as a fallback for
    // plans that have not been translated in Shopify yet. Order: small, medium, large.
    const sizes = window.tsSellingPlanSizeTokens || [["Small"], ["Medium"], ["Large"]];
    const matchesSize = (name, tokens) => tokens.some(token => token && name.includes(token));

    if (event.target && event.target.name == "subscription_selling_plan") {
      const sizeIndex = sizes.findIndex(tokens => matchesSize(event.target.dataset.name, tokens));

      if (sizeIndex >= 0) {
        const variantEl = this.querySelector(`.eg-subscription-v6__variant:nth-of-type(${sizeIndex + 1})`);
        const variantInput = variantEl && variantEl.querySelector('input[type="radio"][name="variant-id"]');

        // The variant change re-runs this update, otherwise the labels are refreshed below
        // for the newly selected dog size
        if (variantInput && !variantInput.checked) {
          variantInput.checked = true;
          variantInput.dispatchEvent(new Event("change", { bubbles: true }));
          return;
        }
      }
    }

    const currentPlan = this.querySelector('[name="subscription_selling_plan"]:checked');
    const currentPlanLabel = currentPlan.dataset.name;
    const savingsTemplate = window.tsSubscriptionStrings.savingsTemplate;
    let currentQuantity = 0;

    this.isSubscribe = this.querySelector('[name="purchase-type"]:checked').value == "subscribe";
    this.setAttribute("data-purchase-type", this.querySelector('[name="purchase-type"]:checked').value);

    this.querySelectorAll("[data-variant]").forEach(variantElement => {
      const variant = this.dynamicData.find(item => item.id === parseInt(variantElement.dataset.variant));

      let currentVariantPlan = false;
      let frequency = 0;

      variant.sellingPlans.forEach(plan => {
        if (sizes.some(tokens => matchesSize(currentPlanLabel, tokens) && matchesSize(plan.name, tokens))) {
          const planFrequency = plan.name.match(/\d+/);

          frequency = planFrequency ? parseInt(planFrequency[0]) : 0;
          currentVariantPlan = plan;
        }
      });
  
      const variantInput = variantElement.querySelector("input");
      const variantQuantity = parseInt(variant.title.match(/\d+/)[0]);

      const variantsSubtitle = this.querySelector("[data-subtitle]");
      const subscriptionLabel = variantElement.querySelector("[subsription-label]");
      const subscriptionUnit = variantElement.querySelector(".eg-subscription-v6__variant-unit span");
      const priceElement = variantElement.querySelector(".eg-subscription-v6__variant-price--main");
      const compareElement = variantElement.querySelector(".eg-subscription-v6__variant-price--compare");
      const savingsElements = variantElement.querySelectorAll(".eg-subscription-v6__variant-discount");

      const allPlansInputs = this.querySelectorAll(".eg-subscription-v6__plans input");
      
      if (variantInput.checked) {
        currentQuantity = variantQuantity;

        allPlansInputs.forEach((allPlansInput,index) => {
          allPlansInput.value = variant.sellingPlans[index].id;
          allPlansInput.dataset.name = variant.sellingPlans[index].name;
        })

        // Discount line ("Renews every {days} days") and one-time link follow the selected option
        this.querySelectorAll("[data-renew-days]").forEach(element => {
          element.textContent = frequency;
        })
        this.querySelectorAll("[data-onetime-price]").forEach(element => {
          element.textContent = variant.priceMoney;
        })

        const formPrices = this.querySelectorAll('.eg-subscription-v6__form-subscription [data-button-price]');
        formPrices.forEach(formPrice => {
          if (this.isSubscribe) {
            formPrice.innerHTML = currentVariantPlan.priceMoney;
          } else {
            formPrice.innerHTML = variant.priceMoney;
          }
        })

        if (variantsSubtitle) {        
          if (this.isSubscribe) {
            let variantsSubtitleTemplate = window.tsSubscriptionStrings.subtitleSbsTemplate;
            variantsSubtitle.innerHTML = variantsSubtitleTemplate;
          } else {
            let variantsSubtitleTemplate = window.tsSubscriptionStrings.subtitleOtpTemplate;
            variantsSubtitle.innerHTML = variantsSubtitleTemplate.replace("{{ diff_price }}", currentVariantPlan.diffMoney);
          }
        }
      }

      // const isVariantSubscription = variantInput.hasAttribute("data-selling");
      
      const variantPrice = this.isSubscribe ? currentVariantPlan.price : variant.price;
      const variantPriceMoney = this.isSubscribe ? currentVariantPlan.priceMoney : variant.priceMoney;
      const variantCompareMoney = this.isSubscribe ? currentVariantPlan.compareMoney : variant.compareMoney;
      const savings = this.isSubscribe ? currentVariantPlan.savings : variant.savings;
      
      // Chews in one unit (jar, bundle...) from the product metafield custom.chews_per_unit
      const chewsPerUnit = parseInt(this.dataset.chewsPerUnit, 10) || 60;
      const unitPrice = Math.round(variantPrice / (variantQuantity * chewsPerUnit));
      const unitPriceMoney = Shopify.formatMoney(unitPrice);

      if (subscriptionLabel) {
        const labelTemplate = this.isSubscribe
          ? window.tsSubscriptionStrings.subscriptionLabelTemplate
          : window.tsSubscriptionStrings.onetimeLabelTemplate;

        subscriptionLabel.textContent = labelTemplate
          .replace("{{ frequency }}", frequency)
          .replace("{{ saving }}", unitPriceMoney);
      }
      
      subscriptionUnit.textContent = unitPriceMoney;
      priceElement.textContent = variantPriceMoney;

      if (savings === 0) {
        compareElement.textContent = "";
        savingsElements.forEach(savingsElement => {
          savingsElement.textContent = "";
        })
      } else {
        compareElement.textContent = variantCompareMoney;
        savingsElements.forEach(savingsElement => {
          savingsElement.textContent = savingsTemplate.replace("{{ amount }}", savings);
        })
      }
    })

    const productForm = document.querySelector(".eg-subscription-v6__form-subscription");
    const formVariantId = productForm.querySelector('[name="id"]');
    const formSellinigPlan = productForm.querySelector('[name="selling_plan"]');
    const currentVariant = this.querySelector('[name="variant-id"]:checked');

    formVariantId.value = currentVariant.value;
    if (this.isSubscribe) {
      formSellinigPlan.value = this.querySelector('[name="subscription_selling_plan"]:checked').value;
    } else {
      formSellinigPlan.value = "";
    }

    this.toggleAddButtons(productForm, formVariantId, parseInt(currentVariant.value));

    window.addGiftToCart = (this.isSubscribe && currentQuantity > 1);
  }

  // One-time purchase link (onetime_layout "link"): adds the selected option without a selling plan
  // through the hidden "Try now" submit button, the offer itself stays on subscribe.
  // The cart drawer reads the gift flag once the add request is done, so it is restored on cart update.
  buyOneTime(event) {
    event.preventDefault();

    const productForm = this.querySelector(".eg-subscription-v6__form-subscription");
    const sellingPlanInput = productForm.querySelector('[name="selling_plan"]');
    const onetimeButton = productForm.querySelector(".product-form__submit--otp");
    const sellingPlan = sellingPlanInput.value;
    const addGift = window.addGiftToCart;

    if (!onetimeButton || onetimeButton.disabled) return;

    const restoreGift = () => {
      window.addGiftToCart = addGift;
    };
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      const unsubscribeUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        unsubscribeUpdate();
        unsubscribeError();
        restoreGift();
      });
      const unsubscribeError = subscribe(PUB_SUB_EVENTS.cartError, () => {
        unsubscribeUpdate();
        unsubscribeError();
        restoreGift();
      });
    }

    window.addGiftToCart = false;
    sellingPlanInput.value = "";
    productForm.requestSubmit(onetimeButton);
    sellingPlanInput.value = sellingPlan;
  }

  // Mirrors the sold out handling of the regular buy buttons: the variant input and both
  // submit buttons are disabled and the label is swapped for the sold out message.
  toggleAddButtons(productForm, formVariantId, variantId) {
    const variant = this.dynamicData.find(item => item.id === variantId);
    const isAvailable = variant ? variant.available !== false : true;

    formVariantId.disabled = !isAvailable;

    const onetimeLink = productForm.querySelector("[data-onetime-link]");
    if (onetimeLink) onetimeLink.disabled = !isAvailable;

    productForm.querySelectorAll('[name="add"]').forEach(button => {
      const label = button.querySelector("[data-button-label]");
      const soldOutMessage = button.querySelector(".sold-out-message");

      button.disabled = !isAvailable;
      if (label) label.classList.toggle("hidden", !isAvailable);
      if (soldOutMessage) soldOutMessage.classList.toggle("hidden", isAvailable);
    })
  }
}

customElements.define("eg-subscription-v6", EGSubscriptionV6);